module.exports = {
    language_title:'選擇語言',
    language:'繁體中文',
    company:'公司說明',
    address:'地址',
    service_tel:'服務電話',
    operator:'總機電話',
    complaint_tel:'投訴電話',
    email:'信箱',
    submit:'提交',
    submiting:'提交中...',
    weTeamList:'核心團隊',
    must_import:'請輸入必填',
    scoll:'下拉',
    more:'更多',
    mores:'更多',
    name:'姓名',
    number:'客人數量',
    phone:'電話號碼',
    event:'目的地',
    request:'您的需求',
    privacy:'隱私聲明',
    explain:'Mandarin收集您的個人數據以處理您的請求併回復您。有關更多信息',
    country:'中國',
    project:'個項目',
    guests:'名嘉賓',
    submit_success:'提交成功',
    detail:'詳情咨詢',
    phones:'電話'

}


// WEBPACK FOOTER //
// ./src/i18n/zh_tw.js